var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { Component, Prop } from 'vue-property-decorator';
import ReleaseCom from '../../../components/releaseCom.vue';
import GLOBAL_VUE from '../../../globalVue';
import CommonService from '../../../api/CommonService';
import GoodsStockService from '../../../api/GoodsStockService';
import SelectStockBatch from './SelectStockBatch.vue';
var MulOrderDetailOamount = (function (_super) {
    __extends(MulOrderDetailOamount, _super);
    function MulOrderDetailOamount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingOutDepotOptions = false;
        return _this;
    }
    MulOrderDetailOamount.prototype.selectStockBatch = function (row) {
        this.$refs.SelectStockBatch.show(row, this.rowData.goods_format_id);
    };
    MulOrderDetailOamount.prototype.batchSubmit = function (row) {
        if (row.batch_list.length) {
            var order_detail_oamount_1 = 0;
            row.batch_list.map(function (item) {
                order_detail_oamount_1 = order_detail_oamount_1 + item.order_detail_oamount;
            });
            row.order_detail_oamount = order_detail_oamount_1;
        }
        else {
            row.order_detail_oamount = row.old_order_detail_oamount || 0;
        }
    };
    MulOrderDetailOamount.prototype.close = function () {
        this.$refs.release.hide();
    };
    MulOrderDetailOamount.prototype.showRelease = function () {
        this.initOutDepotOptions();
        this.$refs.release.show({ hasMask: true, className: 'release-wrapper mul-shop-release-wrapper' });
    };
    MulOrderDetailOamount.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.goodsStockService = GoodsStockService.getInstance();
    };
    MulOrderDetailOamount.prototype.mounted = function () {
    };
    MulOrderDetailOamount.prototype.blur_priceAndamount = function (data, name) {
        console.log('------blur_priceAndamount', data, name);
        data.batch_list = [];
        if (data[name] === '') {
            data[name] = 0;
        }
    };
    MulOrderDetailOamount.prototype.save = function () {
        this.$refs.release.hide();
        this.$emit('orderDetailOamountSave', this.data);
    };
    MulOrderDetailOamount.prototype.filterSearch = function (val, row) {
        var _this = this;
        clearTimeout(this.time);
        this.time = setTimeout(function () {
            _this.getOutDepotOptions(val, row);
        }, 500);
    };
    MulOrderDetailOamount.prototype.focusOutDepotId = function (event, row) {
        this.getOutDepotOptions('', row);
    };
    MulOrderDetailOamount.prototype.getOutDepotOptions = function (val, row) {
        var _this = this;
        var params = {
            is_init: 1,
            organ_id: this.organ_id,
        };
        this.loadingOutDepotOptions = true;
        this.commonService
            .getDepotList(params)
            .then(function (res) {
            if (res.data.success) {
                var data = res.data.data || [];
                var index = _this.data.indexOf(row);
                GLOBAL_VUE.$set(_this.data[index], 'outDepotOptions', data);
            }
            _this.loadingOutDepotOptions = false;
        })
            .catch(function () {
            _this.loadingOutDepotOptions = false;
        });
    };
    MulOrderDetailOamount.prototype.calc_stock = function (row) {
        return "" + row.order_remaining_stock + row.sales_unit;
    };
    MulOrderDetailOamount.prototype.initOutDepotOptions = function () {
        var _this = this;
        this.data.forEach(function (row) {
            row.out_depot_id = row.out_depot_id == 0 ? '' : row.out_depot_id;
            _this.getOutDepotOptionsOneOrZero(row);
        });
    };
    MulOrderDetailOamount.prototype.getOutDepotOptionsOneOrZero = function (row, trigger) {
        var data = [];
        if (row.out_depot_id) {
            data.push({
                depot_id: row.out_depot_id,
                depot_name: row.out_depot_name,
            });
        }
        var index = this.data.indexOf(row);
        GLOBAL_VUE.$set(this.data[index], 'outDepotOptions', data);
    };
    MulOrderDetailOamount.prototype.outDepotChange = function (row) {
        var _this = this;
        row.batch_list = [];
        var filterRows = row.outDepotOptions.filter(function (item) { return item.depot_id == row.out_depot_id; });
        row.out_depot_name = filterRows.length > 0 ? filterRows[0].depot_name : '';
        if (this.openedCodeData && this.openedCodeData.isOpenERP) {
            var params = {
                depot_id: row.out_depot_id,
                goods_format_id: this.rowData.goods_format_id
            };
            return this.goodsStockService.getDepotGoodsFormatStock(params).then(function (res) {
                var data = res.data.data;
                row.order_remaining_stock = data.order_remaining_stock;
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
            });
        }
    };
    MulOrderDetailOamount.prototype.handleInput = function (value, row, field) {
        if (value === '') {
            row[field] = '';
            return;
        }
        var scale = this.amountScale;
        var regex = new RegExp("^\\d*\\.?\\d{0," + scale + "}$");
        if (!regex.test(value)) {
            row[field] = value.slice(0, value.indexOf('.') + parseInt(scale) + 1);
        }
    };
    __decorate([
        Prop({
            type: Object,
        })
    ], MulOrderDetailOamount.prototype, "rowData", void 0);
    __decorate([
        Prop({
            type: Boolean,
            default: true
        })
    ], MulOrderDetailOamount.prototype, "isHideGiftAmount", void 0);
    __decorate([
        Prop({
            type: Array,
            default: [],
        })
    ], MulOrderDetailOamount.prototype, "data", void 0);
    __decorate([
        Prop({
            type: String,
            default: '',
        })
    ], MulOrderDetailOamount.prototype, "type", void 0);
    __decorate([
        Prop({
            default: '',
        })
    ], MulOrderDetailOamount.prototype, "organ_id", void 0);
    __decorate([
        Prop({
            default: {}
        })
    ], MulOrderDetailOamount.prototype, "formData", void 0);
    MulOrderDetailOamount = __decorate([
        Component({
            components: {
                'release-com': ReleaseCom,
                'select-stock-batch': SelectStockBatch,
            },
            computed: __assign({}, mapGetters({
                openedCodeData: 'openedCodeData',
                canSelectBatch: 'canSelectBatch',
            }), { amountScale: function () {
                    return this.$store.getters.getBusinessConfig(this.formData.business_id, 'amount_scale', '4');
                } })
        })
    ], MulOrderDetailOamount);
    return MulOrderDetailOamount;
}(Vue));
export default MulOrderDetailOamount;
